module.exports = __webpack_public_path__ + "img/qrcode.c35e1db8.png";